import prb from '../assets/problem-solving-skills.png'
import pass from '../assets/favorite.png'
import team from '../assets/customer-satisfaction.png'
import App from '../assets/financial-thinking.png'
import skills from '../assets/interpersonal.png'
import abi from '../assets/abilities.png'
import agency from '../assets/agency.jpeg'
import info from '../assets/info.png'
import Fiver from '../assets/fiver.avif'
import Upwork from '../assets/upwrok1.png'
import project1 from '../assets/O.png'
import jobit from '../assets/re.png'
import jobit1 from '../assets/t.png'
import foodorder from '../assets/foodorder.png'
import NextWebsite from '../assets/NextWebsite.png'
import appointments from '../assets/pro.png'
import ecoo from '../assets/ecoo.png'
import bg from '../assets/lastproject.png'
import car from '../assets/car.png'
import saas from '../assets/saas.png'
import landing from '../assets/landingg.PNG'
import plat from '../assets/pla.PNG'
import tour from '../assets/tour.png'
import world1 from '../assets/world.png'
import binisurf from '../assets/bini.png'
import  moumoufrerecar from '../assets/moumoufrerecar.png'
import  eliterent from '../assets/eliterent.png'
import  taghazoutmotorent from '../assets/taghazoutmotorent.png'
import  taghazoutlaundry from '../assets/taghazoutlaundry1.png'
import  quidene from '../assets/quidene01.png'
const services = [
    {
      title: "Problem Solver",
      desc:'Skilled at identifying and solving complex problems.',
       icon: prb,
    },
    
    {
      title: "Passionate Developer",
      desc:'Enthusiastic about programming and dedicated to creating high-quality software solutions.',
      icon: pass,
    },
    {
      title: "Good Team ",
      desc:'Collaborative, supportive, and able to work effectively with others.',
   icon: team,
    },
    {
        title: "Business acumen",
        desc:'Understanding of business processes, markets, and trends, and able to make informed decisions and identify growth opportunities.',
         icon: App,
      },
      {
        title: "Interpersonal Skills",
        desc:'Able to communicate effectively, build relationships, and collaborate in a team environment.',
       icon: skills,
      },
      {
        title: "Ability to Learn, Adapt and Grow",
        desc:'Continuously learning new skills, adapting to change, and taking on new challenges.',
     icon: abi,
      },
      

    
  ];
  const experiences = [
    {
      title: "Full-stack developer",
      company_name: "UpWork",
      icon: Upwork,
      iconBg: "#383E56",
      date: "February 2024 - January 2025",
      points: [
        "I'm a full-stack web developer specializing in creating dynamic, user-centric web applications. I work remotely on Upwork, delivering high-quality projects that leverage modern technologies like React, Next.js, Laravel, and more. Passionate about building seamless digital experiences with a focus on clean code and performance."
      ],
    },
    {
      title: "Full-stack developer",
      company_name: "Tekency Web Digital Agency",
      icon: agency,
      iconBg: "#383E56",
      date: "September 2024",
      points: [
        "I worked at Tekency Web Digital Agency, a company specialized in web and mobile development applications for iOS and Android, primarily using the Shopify platform. My role has helped contribute to the creation of applications by collaborating with multidisciplinary teams, user-friendly interface design, and fixing cross-platform compatibility issues."
      ],
    },
    {
      title: "Full-stack developer",
      company_name: "Info-Market Meknes",
      icon: info,
      iconBg: "#E6DEDD",
      date: "July 2023",
      points: [
        "Development of a complete e-commerce site for a company specializing in computers and hardware.",
        "Responsible for the full-stack development process, including front-end design, back-end integration, basic data management, and deployment. Implementation of user-friendly interfaces and effective inventory management systems to improve customer experience and streamline business operations."
      ],
    },
    {
      title: "Full-stack developer",
      company_name: "Fiverr",
      icon: Fiver,
      iconBg: "#383E56",
      date: "January 2022 - January 2023",
      points: [
        "As a freelance developer on Fiverr and Upwork, I created various portfolios and e-commerce websites for an international clientele. I have successfully completed numerous projects, ranging from front-end design to back-end integration, including database management. My work is characterized by intuitive user interfaces and efficient content management systems, meeting the specific needs of each client and improving their online presence."
      ],
    },
  ];
  
  const Skill_data = [
    {
      skill_name: "Html 5",
      Image: "/html.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Css",
      Image: "/css.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Java Script",
      Image: "/js.png",
      width: 65,
      height: 65,
    },
    {
      skill_name: "Tailwind Css",
      Image: "/tailwind.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "React",
      Image: "/react.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Redux",
      Image: "/redux.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "React Query",
      Image: "/reactquery.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Type Script",
      Image: "/ts.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Next js 13",
      Image: "/next.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Framer Motion",
      Image: "/framer.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Stripe Payment",
      Image: "/stripe.webp",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Node js",
      Image: "/node-js.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Mongo db",
      Image: "/mongodb.png",
      width: 40,
      height: 40,
    },
  
  ];
  
const Socials = [
    {
      name: "Discord",
      src: "/instagram.svg",
    },
    {
      name: "Facebook",
      src: "/facebook.svg",
    },
    {
      name: "Instagram",
      src: "/discord.svg",
    },
  ];
  
  
  
   const Frontend_skill = [
    {
      skill_name: "Html 5",
      Image: "/html.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Css",
      Image: "/css.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Java Script",
      Image: "/js.png",
      width: 65,
      height: 65,
    },
    {
      skill_name: "Tailwind Css",
      Image: "/tailwind.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Material UI",
      Image: "/mui.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "React",
      Image: "/react.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Redux",
      Image: "/redux.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "React Query",
      Image: "/reactquery.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Type Script",
      Image: "/ts.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Next js 13",
      Image: "/next.png",
      width: 80,
      height: 80,
    },
  ];
  
   const Backend_skill = [
    {
      skill_name: "Node js",
      Image: "/node-js.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Express js",
      Image: "/express.png",
      width: 80,
      height: 80,
    },
    {
      skill_name: "Mongo db",
      Image: "/mongodb.png",
      width: 40,
      height: 40,
    },
    {
      skill_name: "Fire base",
      Image: "/Firebase.png",
      width: 55,
      height: 55,
    },
    {
      skill_name: "Postger SQL",
      Image: "/postger.png",
      width: 70,
      height: 70,
    },
    {
      skill_name: "My SQL",
      Image: "/mysql.png",
      width: 70,
      height: 70,
    },
    {
      skill_name: "Prisma",
      Image: "/prisma.webp",
      width: 70,
      height: 70,
    },
    {
      skill_name: "Laravel",
      Image: "https://logowik.com/content/uploads/images/laravel8530.jpg",
      width: 90,
      height: 150,
    },
  ];
  
  const Full_stack = [
    {
      skill_name: "React Native",
      Image: "/ReactNative .png",
      width: 70,
      height: 70,
    },
    {
      skill_name: "Tauri",
      Image: "/tauri.svg",
      width: 70,
      height: 70,
    },
    {
      skill_name: "Docker",
      Image: "/docker.webp",
      width: 70,
      height: 70,
    },
  
    {
      skill_name: "Figma",
      Image: "/figma.png",
      width: 50,
      height: 50,
    },
  
  ];
  
  
  
 const Other_skill = [
    {
      skill_name: "Go",
      Image: "/go.png",
      width: 60,
      height: 60,
    },
  ];
const projects = [
  {
  name: "Quidene – Luxury Fashion Website",

  description:
    "A modern luxury fashion website for Quidene, showcasing premium clothing collections with a clean and elegant shopping experience. Designed with a stylish UI, responsive layouts, and optimized performance to deliver a high-end brand presence online.",

  tags: [
    { name: "Laravel", color: "text-red-500" },
    { name: "PHP", color: "text-indigo-400" },
    { name: "TailwindCSS", color: "text-sky-400" },
    { name: "JavaScript", color: "text-yellow-400" },
  ],

  image: quidene,
  link: "http://quidene01.com/",
  source_code_link: "https://github.com/aminedevaj",
},
  {
  name: "Taghazout Laundry – Laundry Service Website",

  description:
    "A modern laundry service website for Taghazout Laundry, allowing customers to explore services, schedule pickups, upload required details, and book laundry services online. Built with a clean UI and optimized for fast and easy reservations across Morocco.",

  tags: [
    { name: "Laravel", color: "text-red-500" },
    { name: "PHP", color: "text-indigo-400" },
    { name: "TailwindCSS", color: "text-sky-400" },
    { name: "JavaScript", color: "text-yellow-400" },
  ],

  image: taghazoutlaundry,
  link: "https://www.taghazoutlaundry.com/",
  source_code_link: "https://github.com/aminedevaj",
},
    {
  name: "Taghazout Moto Rent –  Rental Website",

  description: "A professional car rental website for Taghazout Moto, allowing users to browse available moto view details, upload required documents, and make reservations online. Built with a clean UI and optimized for fast booking, targeting customers across Morocco.",

  tags: [
    { name: "Laravel", color: "text-red-500" },
    { name: "PHP", color: "text-indigo-400" },
    { name: "TailwindCSS", color: "text-sky-400" },
    { name: "JavaScript", color: "text-yellow-400" },
  ],

  image:taghazoutmotorent,
  link: "https://www.taghazoutmotorent.com/",
  source_code_link: "https://github.com/aminedevaj",
}
,

  {
  name: "Elite Rent – Car Rental Website",

  description: "A professional car rental website for Elite Rent, allowing users to browse available vehicles, view details, upload required documents, and make reservations online. Built with a clean UI and optimized for fast booking, targeting customers across Morocco.",

  tags: [
    { name: "Laravel", color: "text-red-500" },
    { name: "PHP", color: "text-indigo-400" },
    { name: "TailwindCSS", color: "text-sky-400" },
    { name: "JavaScript", color: "text-yellow-400" },
  ],

  image: eliterent,
  link: "http://sselitrent.com",
  source_code_link: "https://github.com/aminedevaj",
}
,
// {
//   name: "Moumou Frère Car – Car Rental Website",

//   description: "A professional car rental website for Moumou Frère Car, allowing users to browse available vehicles, view details, upload required documents, and make reservations online. Built with a clean UI and optimized for fast booking, targeting customers across Morocco.",

//   tags: [
//     { name: "Laravel", color: "text-red-500" },
//     { name: "PHP", color: "text-indigo-400" },
//     { name: "TailwindCSS", color: "text-sky-400" },
//     { name: "JavaScript", color: "text-yellow-400" },
//   ],

//   image: moumoufrerecar,
//   link: "https://moumoufrerecar.com",
//   source_code_link: "https://github.com/aminedevaj",
// }
// ,
// {
//   name: "Moumou Frère Car – Car Rental Website",

//   description: "A professional car rental website for Moumou Frère Car, allowing users to browse available vehicles, view details, upload required documents, and make reservations online. Built with a clean UI and optimized for fast booking, targeting customers across Morocco.",

//   tags: [
//     { name: "Laravel", color: "text-red-500" },
//     { name: "PHP", color: "text-indigo-400" },
//     { name: "TailwindCSS", color: "text-sky-400" },
//     { name: "JavaScript", color: "text-yellow-400" },
//   ],

//   image: moumoufrerecar,
//   link: "https://moumoufrerecar.com",
//   source_code_link: "https://github.com/aminedevaj",
// }
// ,
  {
  name: "Moumou Frère Car – Car Rental Website",

  description: "A professional car rental website for Moumou Frère Car, allowing users to browse available vehicles, view details, upload required documents, and make reservations online. Built with a clean UI and optimized for fast booking, targeting customers across Morocco.",

  tags: [
    { name: "Laravel", color: "text-red-500" },
    { name: "PHP", color: "text-indigo-400" },
    { name: "TailwindCSS", color: "text-sky-400" },
    { name: "JavaScript", color: "text-yellow-400" },
  ],

  image: moumoufrerecar,
  link: "https://moumoufrerecar.com",
  source_code_link: "https://github.com/aminedevaj",
}
,



  {
    name: "WorldxMaroc — Global Import & Logistics Solutions in Morocco",
    description: "WorldxMaroc connects Moroccan businesses with trusted international suppliers. We provide import, logistics, warehousing, and distribution services to make global trade simple and efficient.",
    tags: [
      
      { name: "React", color: "text-[#66C1EF]" },
      { name: "tailwindcss", color: "text-yellow-400" },
      { name: "Php", color: "text-[#0f1f]" },
   
    
    ],
    image: world1,
    link:"https://worldxmaroc.com",
    source_code_link: "https://github.com/aminedevaj",
  },
//   {
//   name: "Elit-ea – Automated Prop-Firm",
//   description: "An advanced web platform providing an automated trading robot (EA) aimed at helping traders pass prop firm challenges and manage funded & live accounts with minimal manual effort. Features include lifetime access licenses, set-files, daily AI-optimized settings, support for multiple trading platforms (MT4, MT5, cTrader, DXTrade),",
//   tags: [
//     { name: "MetaTrader 4", color: "text-[#FF9A00]" },
//     { name: "MT5 / cTrader", color: "text-[#66C1EF]" },
//   ],
//   image: elite1, // ila 3andek screenshot dyal site Elit-ea khalih hna
//   link:"https://elit-ea.com/",
//   source_code_link: null, // ma-lqitch link public dyal source code
// },

   {
     name: "Binic Surf House – Taghazout",

      description: "A vibrant surf-house & hostel located in the heart of Taghazout, offering panoramic rooftop terraces, ocean & mountain views, shared kitchen, and dorm & private rooms. Just minutes from Taghazout Beach, ideal for surf, yoga, sunset rides or chilling in a lively communal vibe.",

    tags: [
      
      { name: "React", color: "text-[#66C1EF]" },
      { name: "tailwindcss", color: "text-yellow-400" },
      { name: "Php", color: "text-[#0f1f]" },
   
    
    ],
    image: binisurf,
    link:"https://www.binicsurfhouse.com/",
    source_code_link: "https://github.com/aminedevaj",
  },
  {
    name: "Tours About Morocco",
    description: "A multi-page tour and travel website designed to showcase Morocco’s beautiful destinations. Features include dynamic destination pages, detailed itineraries, user-friendly booking forms, image galleries, and a fully responsive layout. Data from the booking forms is collected and stored directly in Google Sheets for easy backend-less management.",
    tags: [
      { name: "HTML", color: "text-[#FF9A00]" },
      { name: "CSS", color: "text-[#66C1EF]" },
      { name: "JavaScript", color: "text-yellow-400" },
      { name: "PHP", color: "text-[#66C1EF]" },
      { name: "MySQL", color: "text-[#0f1f]" },
    ],
    image: tour,
    link:"https://moroccotourhub.com",
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Platform Education",
    description: "A full-featured multi-page educational website for online courses. Includes a custom video player, playlist system, and course organization. Built with HTML, CSS, and JavaScript on the frontend, while PHP and MySQL handle backend functionalities such as user data storage and course content management.",
    tags: [
      { name: "Html", color: "text-[#FF9A00]" },
      { name: "css", color: "text-[#66C1EF]" },
      { name: "javascript", color: "text-yellow-400" },
      { name: "Php", color: "text-[#66C1EF]" },
      { name: "Mysql", color: "text-[#0f1f]" },
    ],
    image: plat,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Landing page Responsive",
    description: "A clean and modern responsive landing page featuring a sleek registration form that collects full name, email, and phone number. Data is securely transmitted and stored in Google Sheets for simplified CRM or lead generation. Fully optimized for mobile and desktop screens.",
    tags: [
      { name: "Html", color: "text-[#FF9A00]" },
      { name: "css", color: "text-[#66C1EF]" },
      { name: "javascript", color: "text-yellow-400" },
      { name: "Google sheets", color: "text-[#0f1f]" },
    ],
    image: landing,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Text ai image in seconds(Saas).",
    description: "A SaaS web app that allows users to generate images from text prompts using AI. Integrates with Clipdrop API to convert ideas into visuals instantly. Built with HTML and Tailwind CSS for design, and MongoDB for data storage. Ideal for creatives exploring fast AI-generated concepts.",
    tags: [
      { name: "html", color: "text-blue-400" },
      { name: "tailwind", color: "text-[#66C1EF]" },
      { name: "Mongodb", color: "text-[#0f1f]" },
      { name: "Clipdrop", color: "text-gray-400" },
    ],
    image: saas,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "website  a Cryptocurrency",
    description: "A React-based website that uses the CoinGecko API to display live cryptocurrency data. Users can search for different coins and view real-time price, market cap, 24h changes, and rankings. Responsive charts and interactive search provide a modern UX.",
    tags: [
      { name: "react", color: "text-[#66C1EF]" },
      { name: "Api", color: "text-[#0f1f]" },
      { name: "tailwind", color: "text-[#66C1EF]" },
      { name: "Html", color: "text-[#FF9A00]" },
    ],
    image: project1,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Website Food",
    description: "A food and recipe web platform that enables users to browse a variety of meals, discover new dishes, and even place orders. Built with React for dynamic UI, and Node.js backend for scalable operations. Includes food categories, detailed recipes, and search features.",
    tags: [
      { name: "react", color: "text-[#66C1EF]" },
      { name: "Html", color: "text-[#FF9A00]" },
      { name: "Css", color: "text-[#66C1EF]" },
      { name: "Node js", color: "text-[#0BAF3C]" },
    ],
    image: foodorder,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Real Estate Site",
    description: "A modern real estate website built for buying, selling, and renting properties. Users can search listings, view images, and contact agents. Developed using React and SCSS for a clean UI and Laravel for powerful backend management.",
    tags: [
      { name: "react", color: "text-[#CCFFE5]" },
      { name: "scss", color: "text-[#0C788E]" },
      { name: "Laravel", color: "text-[#FF0900]" },
    ],
    image: jobit,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Ecommerce Website",
    description: "A fully functional eCommerce website that allows users to browse and purchase a wide range of products. Includes product categories, discount offers, and cart functionalities. Frontend built with HTML, CSS, and JavaScript; Laravel powers the backend.",
    tags: [
      { name: "Html", color: "text-[#FF9A00]" },
      { name: "css", color: "text-[#0C788E]" },
      { name: "JavaScript", color: "text-[#fff000]" },
      { name: "Laravel", color: "text-[#FF0900]" },
    ],
    image: jobit1,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Portfolio Developer",
    description: "A personal portfolio website showcasing my projects, skills, and experience as a Full Stack Developer. Built with React and modern CSS to highlight a clean UI and responsive layout. Designed to reflect my capabilities across frontend and backend development.",
    tags: [
      { name: "react", color: "text-[#CCFFE5]" },
      { name: "Javascript", color: "text-[#fff000]" },
      { name: "css", color: "text-[#0C788E]" },
    ],
    image: NextWebsite,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "booking Doctor Appointment",
    description: "A doctor appointment booking platform built with React and Tailwind CSS. Offers a clean and user-friendly interface for patients to schedule medical consultations with ease. Focused on providing a seamless and responsive UX.",
    tags: [
      { name: "react", color: "text-[#CCFFE5]" },
      { name: "Tailwind Css", color: "text-[#0C788E]" },
    ],
    image: appointments,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "Full Stack E-commerce Website",
    description: "A scalable full stack e-commerce application enabling global online shopping. Users can browse, filter, and purchase products. Built with React, Node.js, Express, and MongoDB for robust frontend and backend performance.",
    tags: [
      { name: "React", color: "text-[#004C99]" },
      { name: "Node JS", color: "text-[#00CC66]" },
      { name: "MongoDB", color: "text-[#0C78]" },
      { name: "Express JS", color: "text-[#fff]" },
    ],
    image: ecoo,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "WebSite Saas Remove Background Image",
    description: "A SaaS platform designed to help users remove image backgrounds instantly. Uses AI tools and image processing APIs to deliver clean, professional results. Ideal for e-commerce product photos, profile pictures, and design needs.",
    tags: [
      { name: "React", color: "text-[#004C99]" },
      { name: "Node JS", color: "text-[#00CC66]" },
      { name: "MongoDB", color: "text-[#0C78]" },
      { name: "Express JS", color: "text-[#fff]" },
    ],
    image: bg,
    source_code_link: "https://github.com/aminedevaj",
  },

  {
    name: "WebSite MarketPlace Car",
    description: "A full stack car marketplace application built with React, Tailwind, Clerk for auth, Drizzle ORM for DB interactions, and Sendbird for chat. Users can post, search, and connect over car listings in real-time with responsive and performant UX.",
    tags: [
      { name: "React", color: "text-[#004C99]" },
      { name: "Tailwind", color: "text-[#0C788E]" },
      { name: "clerk", color: "text-[#00CC66]" },
      { name: "Drizzle ORM", color: "text-[#0C78]" },
    ],
    image: car,
    source_code_link: "https://github.com/aminedevaj",
  },
];

  export { services ,experiences,Other_skill,projects,Frontend_skill, Full_stack,Backend_skill,Socials,Skill_data};